import { IconPad } from '../IconPad';
import React from 'react';
import useTranslatedField from '../../hooks/useTranslatedField';

import PropTypes from 'prop-types';
export const NameFeature = ({ slug, trimLevel }) => {
  const t = useTranslatedField();
  return (
    <IconPad>
      {t(trimLevel[slug], 'translatedName') || trimLevel[slug].name}
    </IconPad>
  );
};

NameFeature.propTypes={
  slug: PropTypes.string.isRequired,
  trimLevel: PropTypes.object.isRequired
};

export default NameFeature;